import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import { useOffline } from "../../../contexts/OfflineContext";

import Popper from "../../Shared/Popper/Popper";

const UserPopper = ({ handleClose, coordinates }) => {
  const isOffline = useOffline();

  // Custom Link component that prevents navigation when offline
  const Link = ({ children, to, ...rest }) => {
    const handleClick = (e) => {
      if (isOffline) {
        e.preventDefault();
        return;
      }
      
      if (rest.onClick) {
        rest.onClick(e);
      }
    };

    return (
      <ReactRouterLink 
        to={to} 
        {...rest} 
        onClick={handleClick}
        style={isOffline ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
      >
        {children}
      </ReactRouterLink>
    );
  };

  return (
    <Popper
      classes="user-profile-menu"
      coordinates={coordinates}
      handleClose={handleClose}
    >
      <ul>
        <Link to="/my-profile">
          <li className="pointer" onClick={handleClose} style={isOffline ? { opacity: 0.6, cursor: 'not-allowed' } : {}}>
            My Profile
          </li>
        </Link>
        <Link to="/logout">
          <li className="pointer" style={isOffline ? { opacity: 0.6, cursor: 'not-allowed' } : {}}>Log Out </li>
        </Link>
      </ul>
    </Popper>
  );
};

export default UserPopper;
